// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"247":"122469d7","495":"88cf483d"}[chunkId] + ".chunk.css";
};